import React from "react";
import { getContentPageProps, getUniqueIdForContentTypeAlias } from "../../logic/contentLogic";

const FullscreenImage = React.lazy(() => import("../../components/Magazine/modules/fullscreenImageContainer/FullscreenImageContainer.js"));

export const renderFullscreenImage = (content, props = {}) => {
  return <FullscreenImage key={getUniqueIdForContentTypeAlias(content.contentTypeAlias)} content={content} {...getContentPageProps(content)} />;
};
